import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Tag the prerender/static <head> SEO nodes BEFORE React/Helmet mount, so the runtime
// de-dup (components/Seo.jsx) can safely remove ONLY these static duplicates and never a
// react-helmet-managed node (removing a Helmet node caused a removeChild crash on SPA nav).
document
  .querySelectorAll('link[rel="canonical"], script[type="application/ld+json"], meta[name="description"], meta[property^="og:"], meta[name^="twitter:"]')
  .forEach((el) => el.setAttribute('data-prerender', '1'));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('✅ PWA: Service Worker registered successfully:', registration.scope);
      })
      .catch((error) => {
        console.log('❌ PWA: Service Worker registration failed:', error);
      });
  });
}
